import styled, { keyframes } from "styled-components";
import { fadeInAnimation } from "../../lib/animations";

/**
 * Animation for the flashing pricing answer option.
 */
const flashingPricingAnimation = keyframes`
	0% {
		background-position: -100%;
	}
	100% {
		background-position: 200%;
	}
`;
export const Answer = styled.div`
  animation: ease 0.3s forwards ${fadeInAnimation};

  display: inline-block;
  position: relative;
  margin-top: 8px;
  margin-right: 5px;
  padding: 13px;
  font-size: 12px;
  border-radius: 23.5px;
  box-shadow: 0 2px 6px #d8d8d8;
  color: #595d61;
  background-color: white;
  max-width: 100%;
  white-space: nowrap;
  line-height: 1;
  text-overflow: ellipsis;
  vertical-align: middle;
  overflow: hidden;
  cursor: pointer;

  &.delayed {
    opacity: 0;
    animation: ease 0.4s 0.5s forwards ${fadeInAnimation};
  }

  &.active {
    background-color: ${(props) => props.theme.brandColor};
    color: white;
  }

  &.flashing {
    background-image: linear-gradient(-60deg, #00000000, #ffffffb5, #00000000);
    background-size: 500%;
    background-position: 100%;
    background-repeat: no-repeat;
    animation: ${flashingPricingAnimation} 10s ease infinite;
  }

  &.pricing {
    padding: 10px 13px;
    font-size: 11px;
    margin-top: 4px;

    &:last-child {
      background: rgba(${(props) => props.theme.brandColorRGB}, 0.2);
      color: ${(props) => props.theme.brandColor};
    }
  }
}
`;
